import { colors } from '../../colors';
var reviewCard = {
  borderRadius: 0,
  reviewLinkColor: colors.red,
  iconColor: colors.red,
  reviewLinkHoverColor: colors.cherry,
  reviewTextColor: colors.black,
  cardBgColor: colors.white,
  bgColor: colors.paleGrey,
  headlineColor: colors.black,
  boxShadow: 'none',
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default reviewCard;